
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetStaticProps } from "next"
import Head from "next/head"

import useSaleProducts from "@/graphql/hooks/useSaleProducts"
import getFilters from "@/graphql/requests/getFilters"
import SEO from "@/meta/SEO"
import { GoogleAnalytics } from "@/services/GA4/GoogleAnalytics"
import Default from "@/templates/Default"
import { FansiKindExtended } from "@/ts/Global"
import FilterGroup from "@/ts/interfaces/global/FilterGroup"
import useStaticProducts from "@/views/products/functions/useStaticProducts"
import ProductsGridView from "@/views/products-grid"

const FANSI_KIND: FansiKindExtended = "sale"

function SaleProductsPage({ staticFilters }: { staticFilters: FilterGroup }) {
  const { filters } = useStaticProducts({
    staticFilters,
  })

  const { products, isLoading, count, maxPrice } = useSaleProducts()

  if (!filters) return null

  return (
    <>
      <Head>
        <title>Promocje | fansi.pl</title>
        <SEO description="Wyjątkowe okazje, wyprzedaże autorskich kolekcji, specjalne obniżki na produkty od najlepszych Twórców." />
      </Head>
      <GoogleAnalytics />
      <ProductsGridView
        products={products}
        isLoading={isLoading}
        count={count}
        filters={filters}
        maxPrice={maxPrice}
        fansiKind={FANSI_KIND}
      />
    </>
  )
}

SaleProductsPage.Layout = Default

 const _getStaticProps: GetStaticProps = async () => {
  const staticFilters = await getFilters({ onlyCreators: false })
  return { props: { staticFilters }, revalidate: 1 }
}

export default SaleProductsPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/products/sale/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  